<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column class="pa-4">
                <v-breadcrumbs class="pl-0">
                    <v-icon #divider aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                    <a href="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>{{ $t("Главная") }}
                        </v-breadcrumbs-item>
                    </a>
                </v-breadcrumbs>
                <div>
                    <h1 class="section-title-main my-3 font-weight-regular">{{ $t("Проверка знаний") }}</h1>
                    <KnowledgeCheckCards />
                </div>
            </v-layout>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu from '@/components/blocks/common/Header_menu.vue';
import UserMenu from '@/components/blocks/common/User_menu.vue';
import FooterBlock from '@/components/blocks/common/Footer.vue';
import KnowledgeCheckCards from '@/components/view_blocks/Knowledge_check/Knowledge_check_cards.vue';

export default {
  name      : 'KnowledgeCheck',
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    KnowledgeCheckCards,
  },
};
</script>
